import { createHttpClient } from '@adapters/HttpClient';
import { useToast } from '@shared/hooks/use-toast';
import { apiClientWH } from '@shared/services';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { ShipmentStatusMappingAdapter } from '../adapters/shipmentStatusMappingAdapter';
import type { MapShipmentStatusRequest } from '../models/shipmentStatusMapping.types';

interface MapShipmentStatusParams {
  id: number;
  request: MapShipmentStatusRequest;
}

export const useMapShipmentStatus = () => {
  const { toast } = useToast();
  const { t } = useTranslation('shipmentStatusMappingModule');
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ShipmentStatusMappingAdapter(httpClient);

  return useMutation({
    mutationFn: ({ id, request }: MapShipmentStatusParams) => adapter.mapShipmentStatus(id, request),
    onSuccess: (data, variables) => {
      const isUnmap = variables.request.shipment_status_id === null;
      toast({
        title: t(isUnmap ? 'shipmentStatusMapping.toast.unmapSuccess' : 'shipmentStatusMapping.toast.mapSuccess'),
        variant: 'default',
      });

      queryClient.invalidateQueries({ queryKey: ['shipment-status-mappings'] });
      queryClient.invalidateQueries({ queryKey: ['shipment-status-mappings-stats-total'] });
      queryClient.invalidateQueries({ queryKey: ['shipment-status-mappings-stats-unmapped'] });
      queryClient.invalidateQueries({ queryKey: ['shipment-status-mappings-unmapped'] });
    },
    onError: (error: any, variables) => {
      const isUnmap = variables.request.shipment_status_id === null;
      toast({
        title: t(isUnmap ? 'shipmentStatusMapping.toast.unmapError' : 'shipmentStatusMapping.toast.mapError'),
        description: error?.response?.data?.message || error.message,
        variant: 'destructive',
      });
    },
  });
};
